import NavbarComp from "../components/NavbarComps";
import FooterComps from "../components/FooterComps";

// Content
import FaqComps from "../components/FaqComps";

function Faq() {
    return (
        <>
        <NavbarComp />
        <FaqComps />
        <FooterComps />
    </>
    )
}

export default Faq;